import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

export const Chat = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.06187C5.5007 3.06187 3.47227 5.0903 3.47227 7.5896C3.47227 8.79681 3.94368 9.89809 4.70905 10.7033C4.91106 10.9159 4.90253 11.2519 4.69 11.4539C4.47746 11.656 4.1414 11.6474 3.93938 11.4349C2.99176 10.4379 2.4104 9.07678 2.4104 7.5896C2.4104 4.50385 4.91425 2 8 2C11.0858 2 13.5896 4.50385 13.5896 7.5896C13.5896 10.6754 11.0858 13.1792 8 13.1792C7.3314 13.1792 6.68066 13.0613 6.08639 12.8434C5.81109 12.7425 5.66974 12.4375 5.77069 12.1621C5.87163 11.8868 6.17664 11.7455 6.45195 11.8464C6.9283 12.0211 7.45524 12.1173 8 12.1173C10.4993 12.1173 12.5277 10.0889 12.5277 7.5896C12.5277 5.0903 10.4993 3.06187 8 3.06187Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.37728 10.5408C4.66905 10.5701 4.88182 10.8304 4.85254 11.1221L4.7092 12.5502L6.02639 11.8728C6.28716 11.7387 6.60726 11.8413 6.74137 12.1021C6.87547 12.3629 6.7728 12.683 6.51204 12.8171L4.32619 13.9412C4.15316 14.0302 3.94532 14.0174 3.7845 13.9079C3.62368 13.7984 3.53566 13.6096 3.55509 13.416L3.79598 11.0161C3.82526 10.7243 4.08552 10.5115 4.37728 10.5408Z"
      fill="currentColor"
    />
  </svg>
);
